/*
 * @Author:
 * @Date: 2023-03-07 09:52:16
 * @LastEditors: Yuan Wei Lin
 * @LastEditTime: 2023-03-13 16:22:22
 * @Description:
 */

export default {
  GetCurrentTimeType() {
    let text = "";
    let date = new Date();
    if (date.getHours() >= 0 && date.getHours() < 12) {
      text = "上午好";
    } else if (date.getHours() >= 12 && date.getHours() < 18) {
      text = "下午好";
    } else {
      text = "晚上好";
    }
    return text;
  },
};
